import {HttpInterceptorFn} from '@angular/common/http';

import {environment} from '../../environments/environment';
import {APP_VERSION} from './app-version';

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-App-Version': APP_VERSION,
      },
    }),
  );
};
